import React, { useEffect, useState } from 'react';
import PayoutPreferenceAddAccount from '../../common/payment-preference.js';
import { ROLES } from '../../utils/constants.js';
import './add-account.css';
import MetaTags from 'react-meta-tags';
import { useMediaQuery } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2.js';
import DefaultPUWidget from '../../Widgets/PU/Default/index.js';
import DefaultWidget from '../../Widgets/SU/Default/index.js';
import { connect } from 'react-redux';
import PageHeader from '../../common/PageHeader/index.js';

const AddAccount = ({ }) => {
    const isMobile = useMediaQuery('(max-width: 899px)');
    const [user, setUser] = useState({});

    useEffect(() => {
        getUserInformation();
    }, []);

    const getUserInformation = async () => {
        const userId = localStorage.getItem('loggedin_user');
        await axios.get(`/api/users/${userId}`)
            .then((response) => {
                setUser(response.data);
                localStorage.setItem('user', JSON.stringify(response.data));
            })
            .catch((error) => {
                console.log({ error });
            });
    };

    return <div className="container mb-4 mt-4">
        <MetaTags>
            <title>Add Account to Receive $$ Payout &#8211; Best way to make money as an influencer for your exclusive content</title>
            <meta name="description" content="Privaposts is a social media platform that lets influencers make money from their followers by keeping exclusive content hidden until a monthly subscription price has been paid." />
        </MetaTags>

        <Grid2
            container
            spacing={!isMobile ? 2 : 0}
        >
            <Grid2 md={8}>
                <PageHeader title='Add Account' />
                <div className="payout-pref-container mb-4 mt-4">
                    <PayoutPreferenceAddAccount
                        page={'add-account'}
                        user={user}
                        setUser={setUser}
                        getUserInformation={getUserInformation}
                    />
                </div>
            </Grid2>
            {
                !isMobile
                    ? <Grid2 className='pu-homepage__right' md={4}>
                        {
                            user && user.role == ROLES.PU ? <DefaultPUWidget /> : null
                        }
                        {
                            user && user.role == ROLES.SU ? <DefaultWidget /> : null
                        }
                    </Grid2>
                    : null
            }
        </Grid2>
    </div>;
};

export default AddAccount;
